<template>
	<popup class="domains-popup" title="Your domain names" @close="closePopup" noscroll>
		<template v-slot:content>
			<div class="options-container scroll" :class="{'loading':loading}">
				<v-spinner v-if="loading" />
				<domain-entry v-else v-for="domain in domains" :domain="domain" :key="domain.id"
				              @delete="deleteDomain(domain.id)" />
			</div>
			<v-button v-if="!loading" label="Connect new domain" :disabled="!canConnectDomains"
			          class="bottom-entry" @click="newDomainOpen=true" />
			<div class="alert_box orange margin-t-10" v-if="!canConnectDomains">
				<div class="icon">
					<inline-svg :src="require('@/assets/img/warning_icon.svg')" />
				</div>
				<div>
					<router-link to="/billing/choose-your-plan">
						Upgrade your account
					</router-link>
					to a <b>Funnelish™ Plus</b> plan to connect your custom domains.
				</div>
			</div>

			<connect-new-domain-popup v-if="newDomainOpen" @close="newDomainOpen=false" @done="newDomain" />
		</template>

		<template v-slot:actions>
			<v-button label="Cancel" border @click="closePopup"/>
		</template>
	</popup>
</template>

<script>

import API from "@/api"
import VButton from "@/components/base/v-button";
import Popup from "@/components/base/popup";
import VSpinner from "@/components/base/v-spinner";
import ConnectNewDomainPopup from "@/components/popups/domains/connect-new-domain-popup";
import DomainEntry from "@/components/popups/domains/domain-entry";

export default {
	name: "DomainsPopup",
	mixins: [API],
	components: {
		DomainEntry,
		ConnectNewDomainPopup,
		VSpinner,
		Popup,
		VButton
	},
	data() {
		return {
			newDomainOpen: false,
			loading: true,
			domains: [],
		}
	},
	methods: {
		closePopup() {
			this.$emit("close");
		},
		newDomain(domain) {
			console.log("newDomain", domain);
			if (this.domains.indexOf(x => x.id===domain.id) < 0) {
				console.log("pushing:", domain);
				this.domains.push(domain);
			}
		},
		async deleteDomain(id) {
			try {
				let index = this.domains.indexOf(x => x.id==id);
				this.domains.splice(index, 1);
			} catch (e) {
				this.$notify({
					type:"warn",
					group: "main",
					title: "Something went wrong... Please try again later",
				});
				console.error("error", e);
			} finally {
				this.deleting = false;
			}
		},
	},
	async created() {
		try {
			this.loading = true;
			this.domains = await this.api.wsteps.getAllDomains();
		} catch (e) {
			this.$error(e);
		} finally {
			this.loading = false;
		}
	},
	computed: {
		user() {
			return this.$store.state.userInfo;
		},
		canConnectDomains() {
			return this.user && this.user.plan_key &&
					this.user.plan_key !== 'funnelish-apps' &&
					this.user.plan_key !== '7-trial';
		},
	}
}
</script>
<style lang="scss" scoped>
.domains-popup {
	.option-header {
		cursor: inherit;
		height: 40px;
		padding: 4px 15px;
		align-items: center;
		> span {
			display: flex;
			flex: 1;
		}
	}
	.options-container.loading {
		min-height: 100px;
		position: relative;
	}
	.delete_btn {
		position: relative;
		padding: 5px;
		min-width: 30px;
		min-height: 30px;
		width: 36px;
		height: 34px;
	}
}
</style>
